var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 26.666H2.66675V23.9993H4.00008V14.7079C4.00008 8.05732 9.37267 2.66602 16.0001 2.66602C22.6275 2.66602 28.0001 8.05732 28.0001 14.7079V23.9993H29.3334V26.666ZM6.66675 23.9993H25.3334V14.7079C25.3334 9.5301 21.1547 5.33268 16.0001 5.33268C10.8454 5.33268 6.66675 9.5301 6.66675 14.7079V23.9993ZM12.6667 27.9993H19.3334C19.3334 29.8403 17.841 31.3327 16.0001 31.3327C14.1591 31.3327 12.6667 29.8403 12.6667 27.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/Actions.9b554f6d28e0a6c0cf4a708aa99dad91.svg";
export { ForwardRef as ReactComponent };